module.exports = __webpack_public_path__ + "static/media/KansasCity.60e5d238.jpg";